import { createI18n } from "vue-i18n"
import pluralRules from "./rules/pluralization"
import numberFormats from "./rules/numbers.js"
import datetimeFormats from "./rules/datetime.js"
import tr from "./locales/tr.json"


export default createI18n({
    locale: "tr", //import.meta.env.VITE_DEFAULT_LOCALE,
    fallbackLocale: "tr", // import.meta.env.VITE_FALLBACK_LOCALE,
    legacy: false,
    globalInjection: true,
    messages: { tr },
    runtimeOnly: false,
    pluralRules,
    numberFormats,
    datetimeFormats
})